import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
} from '@angular/core';
import { LanguageService } from '@core/language';
import { TranslateService } from '@ngx-translate/core';
import { fadeInOutAnimation } from './app-routing.animation';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { RouterOutlet } from '@angular/router';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { SplashScreenComponent } from '@core/splash-screen/splash-screen.component';
import { NgClass } from '@angular/common';
import { BackgroundImageComponent } from '@shared/components/background-image/background-image.component';
import { datadogRum } from '@datadog/browser-rum';

const SVG_ICONS: Record<string, string> = {
  trash: 'trash.svg',
  pencil: 'pencil.svg',
  send: 'send.svg',
  'exclamation-circle': 'exclamation-circle.svg',
  'arrow-repeat': 'arrow-repeat.svg',
  'check-circle': 'check-circle.svg',
  'exclamation-lg': 'exclamation-lg.svg',
};

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    NgxUiLoaderModule,
    NgClass,
    BackgroundImageComponent,
    SplashScreenComponent,
  ],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations: [fadeInOutAnimation],
})
export class AppComponent implements AfterViewInit {
  title = 'sat';

  constructor(
    public languageService: LanguageService,
    public translateService: TranslateService,
    private el: ElementRef,
    matIconRegistry: MatIconRegistry,
    domSanitizer: DomSanitizer
  ) {
    this.initializeLanguage();
    Object.entries(SVG_ICONS).forEach(([iconName, fileName]) => {
      matIconRegistry.addSvgIcon(
        iconName,
        domSanitizer.bypassSecurityTrustResourceUrl(
          `./assets/icons/${fileName}`
        )
      );
    });
  }

  @HostListener('window:beforeunload')
  onBeforeUnload(): void {
    datadogRum.stopSessionReplayRecording();
    datadogRum.stopSession();
  }

  async initializeLanguage(): Promise<void> {
    await this.languageService.setInitialAppLanguage();

    datadogRum.onReady(() => {
      // todo: initialize RUM session and start session replay recording
    });

    const translations = await import(
      /* webpackChunkName: "translations" */
      `./../assets/i18n/${this.translateService.currentLang}.json`
    );
    this.translateService.setTranslation(
      `${this.translateService.currentLang}`,
      translations
    );
  }

  ngAfterViewInit(): void {
    const appRouteRef = this.el;
    setTimeout(() => {
      appRouteRef.nativeElement.previousElementSibling?.remove();
    }, 800);
  }
}
